var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12V16.18C4 17.874 4 18.72 4.268 19.397C4.698 20.485 5.61 21.342 6.765 21.747C7.483 22 8.383 22 10.182 22C13.33 22 14.904 22 16.162 21.558C18.182 20.848 19.777 19.348 20.532 17.445C21 16.261 21 14.779 21 11.815V9.27C21 6.2 21 4.665 20.152 3.598C19.9071 3.29003 19.6192 3.01892 19.297 2.793C18.385 2.15 17.15 2.024 15 2",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 12C20.9999 12.8839 20.6488 13.7317 20.0237 14.3568C19.3987 14.9818 18.5509 15.333 17.6669 15.333C17.0009 15.333 16.2159 15.217 15.5689 15.39C15.2863 15.466 15.0287 15.6149 14.8218 15.8218C14.6148 16.0287 14.4659 16.2864 14.3899 16.569C14.2169 17.216 14.3329 18.001 14.3329 18.667C14.3329 19.1047 14.2467 19.5381 14.0792 19.9425C13.9117 20.3468 13.6662 20.7143 13.3567 21.0238C13.0472 21.3333 12.6798 21.5788 12.2754 21.7463C11.871 21.9138 11.4376 22 10.9999 22M4.14194 2.44198C5.34894 1.70998 6.40194 2.00498 7.03494 2.47398C7.29394 2.66698 7.42394 2.76298 7.49994 2.76298C7.57594 2.76298 7.70594 2.66698 7.96494 2.47398C8.59794 2.00498 9.65094 1.70998 10.8579 2.44198C12.4419 3.40098 12.7999 6.56598 9.14794 9.23698C8.44994 9.74498 8.10294 9.99998 7.49994 9.99998C6.89694 9.99998 6.54894 9.74498 5.85294 9.23698C2.19994 6.56698 2.55794 3.39998 4.14194 2.44198Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.3e1e6084baeb602a43d69e4e12a24338.svg";
export { ForwardRef as ReactComponent };